import "./column-components.218afc30.js";
import "./column-components.b2a20dc1.js";
import "./column-components.096b396f.js";
import "./column-components.579ac24f.js";
import {useContext as $cbaBG$useContext} from "react";
import $cbaBG$macrostrathyper from "@macrostrat/hyper";
import $cbaBG$classnames from "classnames";
import $cbaBG$reactsvgtextures from "react-svg-textures";


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $62da4c1dca6780f0$exports = {};

$parcel$export($62da4c1dca6780f0$exports, "symbolIndex", () => $62da4c1dca6780f0$export$c6d9e109da1a726e);
$parcel$export($62da4c1dca6780f0$exports, "defaultResolveID", () => $62da4c1dca6780f0$export$fa3dcfced41a86d7);
$parcel$export($62da4c1dca6780f0$exports, "ColumnRect", () => $62da4c1dca6780f0$export$bd00a5f0bbdae1c6);
$parcel$export($62da4c1dca6780f0$exports, "expandDivisionsByKey", () => $62da4c1dca6780f0$export$4467ea85d9c25b6a);
$parcel$export($62da4c1dca6780f0$exports, "ParameterIntervals", () => $62da4c1dca6780f0$export$3562b58415e0fc33);
$parcel$export($62da4c1dca6780f0$exports, "FaciesIntervals", () => $62da4c1dca6780f0$export$dce262ef2f9848fe);
$parcel$export($62da4c1dca6780f0$exports, "FaciesColumnInner", () => $62da4c1dca6780f0$export$31f11f8940a4f84f);
$parcel$export($62da4c1dca6780f0$exports, "CoveredOverlay", () => $62da4c1dca6780f0$export$4bda6a249c917193);
$parcel$export($62da4c1dca6780f0$exports, "LithologySymbolDefs", () => $62da4c1dca6780f0$export$32b4d00c1c066ab2);
$parcel$export($62da4c1dca6780f0$exports, "LithologyBoxes", () => $62da4c1dca6780f0$export$82967efe79c38663);
$parcel$export($62da4c1dca6780f0$exports, "LithologyColumnInner", () => $62da4c1dca6780f0$export$c3fb128eae742d73);
$parcel$export($62da4c1dca6780f0$exports, "LithologyColumn", () => $62da4c1dca6780f0$export$dad64b06365c0af9);
$parcel$export($62da4c1dca6780f0$exports, "SimplifiedLithologyColumn", () => $62da4c1dca6780f0$export$2d6d4af5ce24705c);
$parcel$export($62da4c1dca6780f0$exports, "GeneralizedSectionColumn", () => $62da4c1dca6780f0$export$1d4e21d441ba0238);
$parcel$export($62da4c1dca6780f0$exports, "CarbonateDivisions", () => $62da4c1dca6780f0$export$dbe74d60a4075ab1);
$parcel$export($62da4c1dca6780f0$exports, "SimpleFrame", () => (parcelRequire("ig5HY")).SimpleFrame);
$parcel$export($62da4c1dca6780f0$exports, "GrainsizeFrame", () => (parcelRequire("ig5HY")).GrainsizeFrame);




var $ig5HY = parcelRequire("ig5HY");

var $aVUB5 = parcelRequire("aVUB5");

var $30Gl3 = parcelRequire("30Gl3");


var $kRod1 = parcelRequire("kRod1");
const $62da4c1dca6780f0$var$Lines = (0, $cbaBG$reactsvgtextures).Lines;
const $62da4c1dca6780f0$export$c6d9e109da1a726e = {
    "dolomite-limestone": 641,
    lime_mudstone: 627,
    sandstone: 607,
    siltstone: 616,
    "dolomitic siltstone": 616,
    shale: 620,
    limestone: 627,
    dolomite: 642,
    conglomerate: 602,
    "dolomite-mudstone": 642,
    mudstone: 620,
    "sandy-dolomite": 645,
    quartzite: 702
};
const $62da4c1dca6780f0$var$isCarbonateSymbol = function(d) {
    /*
  Does this FGDC pattern correspond to a carbonate rock?
  */ if (d < 627) return false;
    if (d > 648) return false;
    return true;
};
const $62da4c1dca6780f0$export$fa3dcfced41a86d7 = function(d) {
    // Changed pattern to lithology
    if (d == null) return null;
    const pat = d.fgdc_pattern ?? $62da4c1dca6780f0$export$c6d9e109da1a726e[d.pattern] ?? d.pattern;
    if (pat == null) return null;
    return `${pat}`;
};
const $62da4c1dca6780f0$var$carbonateResolveID = function(d) {
    // Just whether a carbonate or not
    const v = $62da4c1dca6780f0$export$fa3dcfced41a86d7(d);
    if (v == null) return v;
    if ($62da4c1dca6780f0$var$isCarbonateSymbol(v)) return 627;
    else return -1;
};
const $62da4c1dca6780f0$var$__divisionSize = function(d) {
    let { bottom: bottom, top: top } = d;
    if (top < bottom) [top, bottom] = [
        bottom,
        top
    ];
    return [
        bottom,
        top
    ];
};
function $62da4c1dca6780f0$export$bd00a5f0bbdae1c6(props) {
    let { division: d, padWidth: padWidth = false, key: key, width: width, ...rest } = props;
    const scale = (0, $cbaBG$useContext)((0, $aVUB5.ColumnContext)).scale;
    const [bottom, top] = $62da4c1dca6780f0$var$__divisionSize(d);
    const y = scale(top);
    let x = 0;
    if (padWidth) {
        x -= 5;
        width += 10;
    }
    const height = scale(bottom) - y;
    if (key == null) key = d.id;
    return (0, $cbaBG$macrostrathyper)("rect", {
        x: x,
        y: y,
        width: width,
        height: height,
        key: key,
        ...rest
    });
}
const $62da4c1dca6780f0$export$4467ea85d9c25b6a = function(divisions, key) {
    const __ = [
        {
            ...divisions[0]
        }
    ];
    for (let d of Array.from(divisions)){
        const ix = __.length - 1;
        const shouldSkip = d[key] == null || d[key] === __[ix][key];
        if (shouldSkip) __[ix].top = d.top;
        else __.push({
            ...d
        });
    }
    return __;
};
function $62da4c1dca6780f0$export$3562b58415e0fc33(props) {
    const { divisions: divisions, width: width } = (0, $cbaBG$useContext)((0, $aVUB5.ColumnLayoutContext));
    const { padWidth: padWidth, parameter: key, fillForInterval: fillForInterval } = props;
    const newDivisions = $62da4c1dca6780f0$export$4467ea85d9c25b6a(divisions, key);
    if (newDivisions.length === 1) return null;
    return (0, $cbaBG$macrostrathyper)("g", {
        className: key
    }, newDivisions.map((div)=>(0, $cbaBG$macrostrathyper)($62da4c1dca6780f0$export$bd00a5f0bbdae1c6, {
            className: (0, $cbaBG$classnames)(key, div.id),
            division: div,
            padWidth: padWidth,
            fill: fillForInterval(div[key], div),
            width: width
        })));
}
const $62da4c1dca6780f0$export$dce262ef2f9848fe = function(props) {
    const { getFaciesColor: getFaciesColor } = (0, $cbaBG$useContext)((0, $aVUB5.FaciesContext));
    return (0, $cbaBG$macrostrathyper)($62da4c1dca6780f0$export$3562b58415e0fc33, {
        parameter: "facies",
        fillForInterval (param, division) {
            const { facies: facies, facies_color: facies_color } = division;
            return getFaciesColor(facies) || facies_color;
        },
        ...props
    });
};
const $62da4c1dca6780f0$export$31f11f8940a4f84f = $62da4c1dca6780f0$export$dce262ef2f9848fe;
function $62da4c1dca6780f0$export$4bda6a249c917193({ color: color = "rgba(0,0,0,0.5)", patternSize: patternSize = 9, strokeWidth: strokeWidth = 3 }) {
    const UUID = (0, $ig5HY.useUUID)();
    const { divisions: divisions, width: width } = (0, $aVUB5.useColumnLayout)();
    const fill = `url(#${UUID}-covered)`;
    const coveredDivs = divisions.filter((d)=>d.covered);
    return (0, $cbaBG$macrostrathyper)("g.covered-overlay", {}, [
        (0, $cbaBG$macrostrathyper)("defs", [
            (0, $cbaBG$macrostrathyper)($62da4c1dca6780f0$var$Lines, {
                id: `${UUID}-covered`,
                size: patternSize,
                strokeWidth: strokeWidth,
                stroke: color
            })
        ]),
        (0, $cbaBG$macrostrathyper)("g.main", coveredDivs.map((d)=>{
            return (0, $cbaBG$macrostrathyper)($62da4c1dca6780f0$export$bd00a5f0bbdae1c6, {
                division: d,
                width: width,
                fill: fill
            });
        }))
    ]);
}
const $62da4c1dca6780f0$export$32b4d00c1c066ab2 = function(props) {
    let { resolveID: resolveID, divisions: divisions, UUID: UUID, scalePattern: scalePattern } = props;
    if (scalePattern == null) scalePattern = ()=>1;
    if (divisions == null) ({ divisions: divisions } = (0, $cbaBG$useContext)((0, $aVUB5.ColumnContext)));
    const __ = divisions.map((d)=>resolveID(d)).filter((x, i, arr)=>arr.indexOf(x) === i);
    return (0, $cbaBG$macrostrathyper)("defs", __.map(function(id, i) {
        if (id === -1) return null;
        let sz = 100;
        if (scalePattern != null) {
            const scalar = scalePattern(id);
            sz *= scalar;
        }
        return (0, $cbaBG$macrostrathyper)((0, $30Gl3.GeologicPattern), {
            key: i,
            prefix: UUID,
            id: id,
            width: sz,
            height: sz
        });
    }));
};
class $62da4c1dca6780f0$export$82967efe79c38663 extends (0, $ig5HY.UUIDComponent) {
    static #_ = this.contextType = (0, $aVUB5.ColumnLayoutContext);
    static #_2 = this.defaultProps = {
        resolveID: $62da4c1dca6780f0$export$fa3dcfced41a86d7,
        minimumHeight: 0
    };
    constructor(props){
        super(props);
        this.constructLithologyDivisions = this.constructLithologyDivisions.bind(this);
        this.renderEach = this.renderEach.bind(this);
    }
    constructLithologyDivisions() {
        let d, patternID;
        const { divisions: divisions } = this.context;
        const { resolveID: resolveID, minimumHeight: minimumHeight } = this.props;
        const __ = [];
        for (d of Array.from(divisions)){
            const ix = __.length - 1;
            patternID = resolveID(d);
            if (ix === -1) {
                __.push({
                    ...d,
                    patternID: patternID
                });
                continue;
            }
            const sameAsLast = patternID === resolveID(__[ix]);
            const shouldSkip = patternID == null || sameAsLast;
            if (shouldSkip) // Set the top of this division
            __[ix].top = Math.max(__[ix].top, d.top);
            else __.push({
                ...d,
                patternID: patternID
            });
        }
        // Allow removing of items by minimum height
        if (minimumHeight > 0) {
            const nextVals = [];
            for(let i = 0; i < __.length; i++){
                d = __[i];
                const heightTooSmall = d.top - d.bottom < minimumHeight;
                if (heightTooSmall && __[i + 1] != null) {
                    var name;
                    __[i + 1].bottom = d.bottom;
                    if (__[name = i + 1].patternID == null) __[name].patternID = resolveID(d);
                } else nextVals.push(d);
            }
            return nextVals;
        }
        return __;
    }
    renderEach(d) {
        const { width: width } = this.context;
        const className = (0, $cbaBG$classnames)({
            definite: d.definite_boundary,
            covered: d.covered
        }, "lithology");
        let fill = `url(#${this.UUID}-${d.patternID})`;
        if (d.patternID === -1) fill = "transparent";
        return (0, $cbaBG$macrostrathyper)($62da4c1dca6780f0$export$bd00a5f0bbdae1c6, {
            width: width,
            division: d,
            className: className,
            fill: fill
        });
    }
    render() {
        const divisions = this.constructLithologyDivisions();
        const { resolveID: resolveID } = this.props;
        return (0, $cbaBG$macrostrathyper)("g.lithology", [
            (0, $cbaBG$macrostrathyper)($62da4c1dca6780f0$export$32b4d00c1c066ab2, {
                divisions: divisions,
                resolveID: resolveID,
                UUID: this.UUID
            }),
            (0, $cbaBG$macrostrathyper)("g", divisions.map(this.renderEach))
        ]);
    }
}
const $62da4c1dca6780f0$export$c3fb128eae742d73 = $62da4c1dca6780f0$export$82967efe79c38663;
function $62da4c1dca6780f0$export$dad64b06365c0af9(props) {
    const { left: left = 0, shiftY: shiftY = 0, width: width, children: children, clipToFrame: clipToFrame = true } = props;
    return (0, $cbaBG$macrostrathyper)((0, $aVUB5.ColumnLayoutProvider), {
        width: width
    }, (0, $cbaBG$macrostrathyper)((0, $ig5HY.ClippingFrame), {
        className: "lithology-column",
        left: left,
        shiftY: shiftY,
        frame: (0, $ig5HY.SimpleFrame),
        clip: clipToFrame
    }, children));
}
const $62da4c1dca6780f0$var$simplifiedResolveID = function(d) {
    const p = $62da4c1dca6780f0$export$c6d9e109da1a726e[d.fill_pattern];
    if (p != null) return p;
    const fp = d.fill_pattern;
    // Special case for shales since we probably want to emphasize lithology
    if (parseInt(fp) === 624) return $62da4c1dca6780f0$export$fa3dcfced41a86d7(d);
    else return fp;
};
const $62da4c1dca6780f0$export$2d6d4af5ce24705c = (props)=>(0, $cbaBG$macrostrathyper)($62da4c1dca6780f0$export$c3fb128eae742d73, {
        resolveID: $62da4c1dca6780f0$var$simplifiedResolveID,
        ...props
    });
const $62da4c1dca6780f0$export$1d4e21d441ba0238 = function(props) {
    let { children: children, frame: frame, ...rest } = props;
    if (frame == null) frame = (0, $ig5HY.GrainsizeFrame);
    return (0, $cbaBG$macrostrathyper)((0, $ig5HY.ClippingFrame), {
        className: "lithology-column",
        frame: frame,
        ...rest
    }, children);
};
const $62da4c1dca6780f0$export$dbe74d60a4075ab1 = (props)=>(0, $cbaBG$macrostrathyper)($62da4c1dca6780f0$export$c3fb128eae742d73, {
        resolveID: $62da4c1dca6780f0$var$carbonateResolveID,
        ...props
    });
$parcel$exportWildcard($62da4c1dca6780f0$exports, $30Gl3);
$parcel$exportWildcard($62da4c1dca6780f0$exports, $kRod1);


export {$62da4c1dca6780f0$export$c6d9e109da1a726e as symbolIndex, $62da4c1dca6780f0$export$fa3dcfced41a86d7 as defaultResolveID, $62da4c1dca6780f0$export$bd00a5f0bbdae1c6 as ColumnRect, $62da4c1dca6780f0$export$4467ea85d9c25b6a as expandDivisionsByKey, $62da4c1dca6780f0$export$3562b58415e0fc33 as ParameterIntervals, $62da4c1dca6780f0$export$dce262ef2f9848fe as FaciesIntervals, $62da4c1dca6780f0$export$31f11f8940a4f84f as FaciesColumnInner, $62da4c1dca6780f0$export$4bda6a249c917193 as CoveredOverlay, $62da4c1dca6780f0$export$32b4d00c1c066ab2 as LithologySymbolDefs, $62da4c1dca6780f0$export$82967efe79c38663 as LithologyBoxes, $62da4c1dca6780f0$export$c3fb128eae742d73 as LithologyColumnInner, $62da4c1dca6780f0$export$dad64b06365c0af9 as LithologyColumn, $62da4c1dca6780f0$export$2d6d4af5ce24705c as SimplifiedLithologyColumn, $62da4c1dca6780f0$export$1d4e21d441ba0238 as GeneralizedSectionColumn, $62da4c1dca6780f0$export$dbe74d60a4075ab1 as CarbonateDivisions, $fe5bf96defe66407$export$5e9808bef3bd64be as SimpleFrame, $fe5bf96defe66407$export$686c342f9382ceb9 as GrainsizeFrame, $289dfaad57c8b69d$export$f8a3ff1b6bcec62 as GeologicPatternContext, $289dfaad57c8b69d$export$2926ceaa6d8d8b07 as GeologicPatternProvider, $289dfaad57c8b69d$export$3d750f4e9f4d0fc8 as PatternType, $289dfaad57c8b69d$export$9e9c2df1189db669 as GeologicPattern, $9f093bb8daf24897$export$2162bbed7004f389 as PatternDefsProvider, $9f093bb8daf24897$export$85aacc253e576bcf as useGeologicPattern};
//# sourceMappingURL=column-components.fa3ec851.js.map
